<template>
  <div style="height: 600px;">
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">请输入要查询的车辆信息</span>
    </div>
    <div class="checkDL">
      <Input v-model="carNum" placeholder="请输入车牌号" style="width: 200px;margin-left: 5px"/>
      <Select v-model="carCorlor" placeholder="车牌颜色" style="width: 200px;margin-left: 5px">
        <Option v-for="(item,index) in colorType" :value="item.value" :key="index">{{ item.label }}</Option>
      </Select>
      <Input v-model="vehicleRoadLicense" placeholder="请输入道路运输证号" style="width: 200px;margin-left: 5px"/>
      <Input v-model="vin" placeholder="车架号(长度不超过17位)" style="width: 200px;margin-left: 5px"/>
      <Button status="primary" icon="ios-search" style="margin-left: 10px;border-radius: 5px;" @click="commit">搜索</Button>
    </div>

    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">查询结果</span>
    </div>
    <div class="resultFour">{{resultFour}}</div>
  </div>
</template>
<script>
  import {apiGet, apiPost} from "../../utils/api";
  import {hideLoading, showLoading} from "@/utils/util";

  export default {
    name: 'checkVRL',
    data() {
      return {
        carNum: '',
        carCorlor: '',
        vehicleRoadLicense: '',
        vin: '',
        resultFour: '',
        colorType: [
          {
            value: 2,
            label: "黄牌"
          },
          {
            value: 1,
            label: "蓝牌"
          }
        ],
      }
    },
    methods: {
      commit() {
        let self = this;
        //提示填写信息
        if (!this.carNum || !this.carCorlor && (!this.vehicleRoadLicense || !this.vin)) {
          this.$XModal.alert({
            message: '请输入完整信息！',
            status: "error",
          });
          return;
        }
        this.$XModal.confirm("请确认信息无误，确认后查询").then((type) => {
          if (type === "confirm") {
            this.vehicleRoadLicenseV3();
          }
        });
      },
      async vehicleRoadLicenseV3() {
        let params = {
          method: 'vehicleRoadLicenseV3',
          params: {
            vclN: this.carNum,
            vco: this.carCorlor,
            vehicleRoadLicense: this.vehicleRoadLicense,
            vin: this.vin
          }
        }
        showLoading();
        let res = await apiPost("api/order/track/", params.method, params.params);
        hideLoading();
        if (res && res.status === 1) {
          let resData = JSON.parse(res.data);
          if (resData.status === 1001) {
            let data = resData.result;
            let code = parseInt(data.code);
            if (code === 10000) {
              let seqNo = data.seqNo ? data.seqNo : '';//序列号
              let rdTrans = data.rdTrans ? data.rdTrans : '';//道路运输证号
              let certificateState = data.certificateState ? data.certificateState : '';//证照状态
              let businessState = data.businessState ? data.businessState : '';//营运状态
              let vehicleBusinessScope = data.vehicleBusinessScope ? data.vehicleBusinessScope : '';//经营范围
              let licenseIssueOrganCode = data.licenseIssueOrganCode ? data.licenseIssueOrganCode : '';//许可机关
              let maturityWarning = data.maturityWarning ? (parseInt(data.maturityWarning) === 0 ? '有效期超过半月' : '有效期不足半月') : '';//到期预警
              let checkTime = data.checkTime ? this.timestampToTime(parseInt(data.checkTime)) : '';//验证时间
              let startDate = data.startDate ? data.startDate : '';//证件有效期起
              let endDate = data.endDate ? data.endDate : '';//证件有效期止
              let corpRoadTransport = data.corpRoadTransport ? data.corpRoadTransport : '';//经营许可证号
              let ownerName = data.ownerName ? data.ownerName : '';//经营业户名称
              let issueDartp = data.issueDartp ? data.issueDartp : '';//发证机构
              let vcltype = data.vcltype ? data.vcltype : '';//车辆类型
              let vehicleLength = data.vehicleLength ? data.vehicleLength : '';//长
              let vehicleWidth = data.vehicleWidth ? data.vehicleWidth : '';//宽
              let vehicleHigh = data.vehicleHigh ? data.vehicleHigh : '';//高
              let approveTon = data.approveTon ? data.approveTon : '';//车辆总质量

              this.resultFour = "序列号：" + seqNo + '\n道路运输证号：' + rdTrans + '\n证照状态：' + certificateState +
                '\n营运状态：' + businessState + '\t\t到期预警：' + maturityWarning + '\t\t许可机关:' + licenseIssueOrganCode + '\t\t验证时间:' + checkTime +
                '\n经营许可证号:' + corpRoadTransport + '\t\t经营业户名称:' + ownerName + '\t\t发证机构:' + issueDartp +
                '\n证件有效期起:' + startDate + '\t\t证件有效期止:' + endDate + '\t\t经营范围:' + vehicleBusinessScope +
                '\n车辆类型:' + vcltype + '\t\t长:' + vehicleLength + '\t\t宽:' + vehicleWidth + '\t\t高:' + vehicleHigh + '\t\t车辆总质量:' + approveTon;
            } else if (code === 10001) {
              this.resultFour = "查询无结果";
            } else if (code === 10002) {
              this.resultFour = "参数有误";
            } else if (code === 10003) {
              this.resultFour = "请求错误";
            } else if (code === 10004) {
              this.resultFour = "系统错误";
            }
          } else if (parseInt(resData.status) === 1006) {
            this.resultFour = "无结果";
          } else {
            this.resultFour = "查询错误";
          }
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : '接口异常',
            status: "error",
          });
        }
      },
      timestampToTime(timestamp) {
        let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = date.getDate() < 10 ? ('0' + date.getDate()) + ' ' : date.getDate() + ' ';
        let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
        let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      },
    }
  }
</script>
<style scoped>
  .checkDL {
    height: 40%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
  }

  .resultFour {
    /*height: 20%;*/
    margin-top: 10px;
    line-height: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
    white-space: pre;
  }
</style>